import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { MobileHeader } from "./MobileHeader";
import { MobileDrawer } from "./MobileDrawer";
import { usePageMeta } from "./usePageTitle";
import { Breadcrumbs } from "./Breadcrumbs";
import { VersionBadge } from "./VersionBadge";

export function AppLayout() {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const location = useLocation();
	const {
		title: pageTitle,
		description: pageDescription,
		hideTitle = false
	} = usePageMeta();

	useEffect(() => {
		document.title =
			pageTitle === "Mee" || pageTitle === "Mee Admin"
				? "Mee Admin"
				: `${pageTitle} | Mee Admin`;
	}, [pageTitle]);

	// Use the first two path segments as a key to force remount when
	// navigating between sibling routes (e.g. /observations/forms → /observations/submissions)
	const routeKey = location.pathname.split("/").slice(0, 3).join("/");

	// Hide all navigation when embedded in React Native WebView
	if (window.ReactNativeWebView) {
		return (
			<main className="min-h-screen">
				<Outlet />
			</main>
		);
	}

	return (
		<div className="min-h-screen bg-canvas">
			<a
				href="#main-content"
				className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-md focus:top-2 focus:left-2"
			>
				Skip to main content
			</a>
			<Sidebar />
			<MobileHeader onMenuClick={() => setDrawerOpen(true)} />
			<MobileDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
			<main id="main-content" className="xl:pl-[280px]">
				<div className="px-4 py-6 md:px-6 xl:px-8">
					<Breadcrumbs />
					{/* Desktop page title (mobile title is in MobileHeader).
					    Routes can opt out via `hideTitle` in usePageTitle,
					    in which case they must render their own top-level
					    heading. */}
					{!hideTitle && (
						<>
							<h1 className="mb-1 hidden text-3xl font-semibold xl:block">
								{pageTitle}
							</h1>
							{pageDescription && (
								<p className="text-base text-muted-foreground mb-6">
									{pageDescription}
								</p>
							)}
						</>
					)}
					<Outlet key={routeKey} />
				</div>
			</main>
			<VersionBadge />
		</div>
	);
}
